// Store Preview Styled.js
import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../constants/colors'; 

export const PreviewContainer = styled.div`
  padding: 0px;
  overflow-y: auto;
  height: 100vh; // Fill the viewport height
  width: 100%;
  background-color: ${(props) => props.theme?.background_color || '#f5f5f5'};
  display: flex;
  flex-direction: column;
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
  background-color: ${({ theme }) => theme?.card_color || 'initial'};

  h2 {
    margin-top: 10px;
    font-size: 24px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }

  p {
    margin-top: 10px;
    font-size: 16px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }
`;

export const ProductCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${(props) => props.theme?.card_color || '#1c1c1c'};
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;

  .product-content {
    display: flex;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 15px;
  }

  .product-info {
    flex-grow: 1;
    padding-left: 20px;
    text-align: left;
  }

  .product-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    border-radius: 10px;
  }

  h3 {
    margin: 0;
    font-size: 18px;
    color: white;
  }

  p {
    margin: 5px 0;
    color: #d3d3d3;
  }

  .product-price {
    font-size: 16px;
    color: ${({ theme }) => theme?.card_text_color || '#000'};

    .amount {
      font-weight: bold;
    }
  }

  .product-button {
    margin-top: auto;
    width: 100%;
    background-color: ${COLORS.$mainBlue};
    color: ${({ theme }) => theme?.button_text_color || '#FFFFFF'};
    font-weight: bold;
    min-height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    text-decoration: none;
    border-radius: 15px;

    &:hover {
      background-color: ${COLORS.$mainBlueHover};
      color: white;
    }
  }

  .button-text {
    flex-grow: 1;
    text-align: left;
  }

  .button-icon {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  .ant-card-body {
    padding: 0px;
    width: 100%;
    border-radius: 15px;
  }

  &.card-fill-slightly-rounded {
    border-radius: 10px;
    background-color: ${({ theme }) => theme?.card_color || '#2E2E2E'};
  }

  &.card-default {
    border-radius: 5px;
    background-color: ${({ theme }) => theme?.card_color || '#f3f3f1'};
  }
`;

export const SimpleProductCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  background-color: ${({ theme }) => theme?.card_color || '#f3f3f1'};
  border-radius: 17px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s;
  height: 75px;

  &:hover {
    transform: scale(1.02);
  }

  .block__card--pill {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 10px;
    background-color: ${({ theme }) => theme?.card_color || '#f0f0f0'};
    border: none;
    border-radius: 17px;
    text-decoration: none;
    color: inherit; // Ensures the text color is inherited

    &:hover {
      background-color: ${({ theme }) => theme?.card_color || '#e0e0e0'};
    }
  }

  .block__image--pill {
    margin-right: 15px; // 15px space between the image and text

    .base-preview-image {
      width: 55px;
      height: 55px;
      border-radius: 10px;
      object-fit: cover;
    }
  }

  .block__content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .block__content.centered {
    align-items: center;
    width: 100%;
    text-align: center;
  }

  .block__text--pill {
    font-size: 18px;
    color: ${({ theme }) => theme?.card_text_color || 'black'};
    font-weight: bold;
  }

  .price-review {
    display: flex;
    align-items: center;
    margin-top: 5px;

    .product-price {
      font-size: 16px;
      color: ${({ theme }) => theme?.card_text_color || '#000'};

      .amount {
        font-weight: bold;
      }
    }
  }

  &.card-fill-slightly-rounded {
    border-radius: 10px;
    background-color: ${({ theme }) => theme?.card_color || '#2E2E2E'};
  }

  &.card-default {
    border-radius: 5px;
    background-color: ${({ theme }) => theme?.card_color || '#f3f3f1'};
  }
`;

export const CustomCloseButton = styled.button`
  position: fixed;
  bottom: 20px; // Adjust as needed
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid lightgray;
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001; // Ensure it's above other elements
`;

export const CustomModalContent = styled.div`
.ant-modal-content {
  padding: 5px 5px !important;
}

  .ant-modal {
    max-width: 480px !important;
    max-height: 1024px !important;
  }

  .ant-modal-content {
    border-radius: 25px !important;
    background-color: ${({ theme }) => theme?.background_color || 'black'};
    padding: 5px 5px !important;
  }

  .ant-modal-body {
    padding: 5px !important;
    background-color: ${({ theme }) => theme?.background_color || 'black'};
  }

  .ant-modal-wrap {
    background-color: ${({ theme }) => theme?.background_color || 'black'};
  }
`;

export const SectionTitle = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
  color: ${({ theme }) => theme?.card_text_color || 'black'};
`;

export const ScrollableContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: auto;
  width: 100%;
  padding: 10px 0;
`;

export const SocialButtons = styled.div`
  display: flex;
  gap: 10px;

  a {
    text-decoration: none;
  }

  button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

// Existing Styled Components from UserStore Page

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100vh;
    background-color: #000000;
    padding: 20px;
    overflow-y: auto;
`;

export const ProductCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 600px;
    background-color: #1e1e1e;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    .product-content {
        display: flex;
        width: 100%;
        align-items: center;
    }

    .product-image {
        margin-right: 20px;
    }

    .product-info {
        flex: 1;
        color: #fff;

        h3 {
            color: #fff;
            margin-bottom: 5px;
        }

        p {
            color: #ccc;
        }
    }

    .product-button {
        margin-top: 10px;
    }
`;

export const SectionTitleWrapper = styled.h3`
    color: ${({ theme }) => theme?.card_text_color || '#fff'};
    margin-bottom: 27px;
    margin-top: 27px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-align: center;
`;

export const ContentWrapper = styled.div`
  max-width: 750px;
  margin: 0 auto; /* Centers the content horizontally */
  padding: 0 20px; /* Optional: Adds some padding for better appearance */
  flex: 1; /* Allows the container to grow and fill available space */
  display: flex;
  flex-direction: column;
  
  /* Remove or adjust padding-bottom if not necessary */
  padding-bottom: 20px; /* Reduced padding to prevent excessive space */
`;


export const FooterBannerButton = styled.a`
    background-color: #f8f9fa;
    padding: 10px; 
    width: 90%; 
    height: 45px; 
    display: flex;
    margin: auto;
    justify-content: space-between; /* Positions items at the far left and right */
    align-items: center;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    text-decoration: none;
    color: black;
    font-weight: bold;
    border-radius: 50px; /* Rounded corners */
    text-align: center;
    cursor: pointer;

    &:hover {
        background-color: #ebf4ff;
    }
`;

export const FooterLogo = styled.img`
    height: 22px; /* Adjust the size as needed */
    margin-left: 10px; /* Ensure the margin is on the right */
    margin-top: 5px;
`;